































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxTextArea } from 'devextreme-vue/text-area';
import { DxCheckBox, DxSelectBox, DxNumberBox, DxScrollView } from 'devextreme-vue';
import notificationService from '@/services/notificationService';
import repository from '@/services/QuotationConditionsRepository';
import cPopup from '@/components/default/Popup.vue';
import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxItem, DxLabel } from 'devextreme-vue/form';

@Component({
  components: {
    DxCheckBox,
    DxSelectBox,
    DxNumberBox,
    DxSimpleItem,
    DxGroupItem,
    DxForm,
    DxLabel,
    DxItem,
    DxTextArea,
    DxScrollView,
    DxRequiredRule,
    cPopup,
  },
})
export default class QuotationConditionDialog extends Vue {
  @Prop({ required: false })
  public conditionId?: string;

  @Prop({ required: false, default: false })
  public show?: boolean;

  public condition: any = {
    id: null,
    codeRefs: [],
    projectTypes: [],
    workTypes: [],
    value: '',
  };

  public loading: boolean = false;
  public saving: boolean = false;

  public hideDialog() {
    this.$emit('hide');
  }

  public reset() {
    this.condition = {
      id: null,
      codeRefs: [],
      projectTypes: [],
      workTypes: [],
      value: '',
    };
  }

  public mounted() {
    if (this.conditionId && this.conditionId !== '') {
      this.loadCondition(this.conditionId);
    }
  }

  public async loadCondition(id: string) {
    try {
      this.loading = true;
      this.condition = (await repository.getSingle(id)).data;
    } catch {
      notificationService.failedToLoad();
    } finally {
      this.loading = false;
    }
  }

  get title() {
    return this.condition.id ? this.$t('objects.quotationConditions.EditTitle') : this.$t('objects.quotationConditions.AddTitle');
  }

  public async save() {
    try {
      const form: any = this.$refs.quotationConditionsForm;
      const validationResult = form.instance.validate();
      if (validationResult.isValid) {
        this.saving = true;
        this.condition.id ? await repository.update(this.condition) : await repository.create(this.condition);
        notificationService.saved();
        this.$emit('saved');
      } else {
        notificationService.invalidForm();
      }
    } catch {
      notificationService.failedToSave();
    } finally {
      this.saving = false;
    }
  }

  get articlesOptions() {
    return { items: this.$store.getters['articles/items'], valueExpr: 'name', displayExpr: 'name' };
  }
  get projecttypesOptions() {
    const catalog = this.$store.getters['catalogs/list']('ProjectTypes') as ICatalogList;
    return { items: catalog ? catalog.values : [] };
  }
  get worktypesOptions() {
    const catalog = this.$store.getters['catalogs/list']('WorkTypes') as ICatalogList;
    return { items: catalog ? catalog.values : [] };
  }

  @Watch('conditionId')
  public onPropertyChanged(value: string, oldValue: string) {
    if (value && value !== '') {
      this.loadCondition(value);
    } else {
      this.reset();
    }
  }
}
